var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgBookmark = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M12,16.9216777 L5.43592865,21.6103001 C4.93952729,21.9648725 4.25,21.6100294 4.25,21 L4.25,5 C4.25,3.48121694 5.48121694,2.25 7,2.25 L17,2.25 C18.5187831,2.25 19.75,3.48121694 19.75,5 L19.75,21 C19.75,21.6100294 19.0604727,21.9648725 18.5640714,21.6103001 L12,16.9216777 Z M18.25,5 C18.25,4.30964406 17.6903559,3.75 17,3.75 L7,3.75 C6.30964406,3.75 5.75,4.30964406 5.75,5 L5.75,19.542608 L11.5640714,15.3896999 C11.8248445,15.2034334 12.1751555,15.2034334 12.4359286,15.3896999 L18.25,19.542608 L18.25,5 Z"
  }));
};
export default SvgBookmark;